const IndonesianHairstudio = {
    beranda: 'Beranda',
    visiMisi: 'Visi Misi',
    // cerita: 'Cerita',
    tentangKami: 'Tentang Kami',
    lokasi: 'Lokasi',
    kontak: 'Kontak',
    karir: 'Karir',
    lainnya: 'Lainnya',
}

export default IndonesianHairstudio;